//PC_XX_05 importing the Client.j and Constant.js file

import { WfhConstant, dashboardApiIndex } from '../constant';
import { clientOff, dashboardClient } from './client';
import moment from 'moment';
import { encryptStorage } from '../constant';
import * as forge from 'node-forge';
//PC_XX_05 importing the axios
import axios from 'axios';

//PC_FD_19 function getInsiteByDomain gets triggered
export const getInsiteByDomain = async (attrition_data) => {
    let body = {
        modulename: dashboardApiIndex.modulename.dashboard,
        methodname: dashboardApiIndex.methodname.getInsiteByDomain,
        payload: attrition_data,
    };
    //PC_FD_20 call the client function
    const response = await dashboardClient(body);
    return response; //PC_FD_24 return the response
};

//PC_FD_36 function getExitByGender gets triggered
export const getExitByGender = async (attrition_data) => {
    try {
        let body = {
            modulename: dashboardApiIndex.modulename.dashboard,
            methodname: dashboardApiIndex.methodname.getExitByGender,
            payload: attrition_data,
        };
        //PC_FD_37 call the client function
        const response = await dashboardClient(body);
        return response; //PC_FD_41 return the response
    } catch (error) {
        console.log(error.message);
    }
};

//PC_FD_53 function getAttritionByTenure gets triggered
export const getAttritionByTenure = async (attrition_data) => {
    let body = {
        modulename: dashboardApiIndex.modulename.dashboard,
        methodname: dashboardApiIndex.methodname.getAttritionByTenure,
        payload: attrition_data,
    };
    //PC_FD_54 call the client function
    const response = await dashboardClient(body);
    return response; //PC_FD_58 return the response
};

//PC_FD_70 function getAttritionByReason gets triggered
export const getAttritionByReason = async (attrition_data) => {
    let body = {
        modulename: dashboardApiIndex.modulename.dashboard,
        methodname: dashboardApiIndex.methodname.getAttritionByReason,
        payload: attrition_data,
    };
    //PC_FD_71 call the client function
    const response = await dashboardClient(body);
    return response; //PC_FD_75 return the response
};

//reason type
export const getReasonType = async () => {
    let body = {
        modulename: dashboardApiIndex.modulename.dashboard,
        methodname: dashboardApiIndex.methodname.ReasonType,
        payload: {},
    };
    //PC_FD_71 call the client function
    const response = await dashboardClient(body);
    return response; //PC_FD_75 return the response
};

//designation
export const getDesignation = async () => {
    let body = {
        modulename: dashboardApiIndex.modulename.dashboard,
        methodname: dashboardApiIndex.methodname.designation,
        payload: {},
    };
    //PC_FD_71 call the client function
    const response = await dashboardClient(body);
    return response; //PC_FD_75 return the response
};

/**
 * PC_Cc_08
 * The methodname , module name and url are got form constant.js file and passed in the body for dashBoardClient function
 */
export const getCountData = async (role) => {
    let body = {
        modulename: dashboardApiIndex.modulename.dashboard,
        methodname: dashboardApiIndex.methodname.countData,
        payload: {
            role: role,
            roleId: encryptStorage.getItem('employeeId'),
        },
    };
    const response = await dashboardClient(body);

    /**
     * Pc_Cc_09
     * The response from axios gets returned to the countComponent.jsx
     */
    return response;
};

/**
 * PC_Ac_08
 * The methodname , module name and url are got form constant.js file and passed in the body for dashBoardClient function
 */
export const getAnnouncemetData = async (data = '') => {
    let body = {
        modulename: dashboardApiIndex.modulename.dashboard,
        methodname: dashboardApiIndex.methodname.announcementData,
        payload: {
            id: data,
        },
    };
    const response = await dashboardClient(body);

    /**
     * Pc_Ac_09
     * The response from axios gets returned to the aanouncementComponent.jsx
     */
    return response;
};

/**
 * PC_Sc_08
 * The methodname , module name and url are got form constant.js file and passed in the body for dashBoardClient function
 */
export const getSpotlightData = async () => {
    let body = {
        modulename: dashboardApiIndex.modulename.dashboard,
        methodname: dashboardApiIndex.methodname.spotlightData,
        payload: {},
    };
    const response = await dashboardClient(body);

    /**
     * Pc_Sc_09
     * The response from axios gets returned to the spotlightComponent.jsx
     */
    return response;
};

export const getConcernData = async (data) => {
    const datum = {
        role: data,
        roleId: encryptStorage.getItem('employeeId'),
    };
    let body = {
        modulename: dashboardApiIndex.modulename.dashboard,
        methodname: dashboardApiIndex.methodname.concernData,
        payload: datum,
    };
    const response = await dashboardClient(body);
    return response;
};

/**
 * PC_MTc_08
 * The methodname , module name and url are got form constant.js file and passed in the body for dashBoardClient function
 */
export const getMyToDoData = async (data = '') => {
    // const datum = {
    //     roleId: encryptStorage.getItem('employeeId'),
    // };

    // let body = {
    //     modulename: dashboardApiIndex.modulename.dashboard,
    //     methodname: dashboardApiIndex.methodname.myToDo,
    //     payload: datum
    // };
    const config = {
        method: 'get',
        // url: `https://workdaynp.avasoft.com/apiservice/hive/${encryptStorage.getItem('userId')}/todos?date=${moment().format('YYYY-MM-DD')}`,
        url: `https://hiveapi.avasoft.com/todos/hive?date=${moment().format('YYYY-MM-DD')}&userId=${encryptStorage.getItem('employeeId')}`,

        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',

            Authorization: 'Bearer ' + encryptStorage.getItem('token'),
        },
    };
    const response = await axios(config);

    /**
     * Pc_MTc_09
     * The response from axios gets returned to the spotlightComponent.jsx
     */

    return response;

    // const response = await dashboardClient(body);
    // return response;
};
export const selectClickedNotification = async () => {
    const datum = {
        // id: encryptStorage.getItem('NotificationId'),
        id: 43503,
    };
    let body = {
        modulename: WfhConstant.modulename.leave,
        methodname: WfhConstant.methodname.selectClickedNotification,
        payload: datum,
    };

    const response = await clientOff(body);
    return response;
};

export const getMyTeamData = async (data = '') => {
    const datum = {
        roleId: encryptStorage.getItem('employeeId'),
        search: data.search,
    };
    let body = {
        modulename: dashboardApiIndex.modulename.dashboard,
        methodname: dashboardApiIndex.methodname.myTeam,
        payload: datum,
    };
    const response = await dashboardClient(body);
    return response;
};

/**
 * PC_APc_08
 * The methodname , module name and url are got form constant.js file and passed in the body for dashBoardClient function
 */

export const getAppreciationData = async (data = '') => {
    // let id = ""
    // if (data.id) id = data.id
    // //
    let body = {
        modulename: dashboardApiIndex.modulename.dashboard,
        methodname: dashboardApiIndex.methodname.appreciationData,
        payload: {
            id: data,
        },
    };
    const response = await dashboardClient(body);

    /**
     * Pc_Apc_09
     * The response from axios gets returned to the spotlightComponent.jsx
     */
    return response;
};

/**
 * PC_Pc_08
 * The methodname , module name and url are got form constant.js file and passed in the body for dashBoardClient function
 */
export const getPolicyData = async (data = '') => {
    let body = {
        modulename: dashboardApiIndex.modulename.dashboard,
        methodname: dashboardApiIndex.methodname.policyData,
        payload: {},
    };
    const response = await dashboardClient(body);

    /**
     * Pc_pc_09
     * The response from axios gets returned to the employeePoliciesComponent.jsx
     */
    return response;
};

/**
 * PC_Fc_08
 * The methodname , module name and url are got form constant.js file and passed in the body for dashBoardClient function
 */
export const getFAQData = async (data = '') => {
    let body = {
        modulename: dashboardApiIndex.modulename.dashboard,
        methodname: dashboardApiIndex.methodname.faqData,
        payload: {},
    };
    const response = await dashboardClient(body);

    /**
     * Pc_Fc_09
     * The response from axios gets returned to the employeeFAQComponent.jsx
     */
    return response;
};

/**
 * PC_Tc_08
 * The methodname , module name and url are got form constant.js file and passed in the body for dashBoardClient function
 */
export const getEmpTeamData = async (data = '') => {
    let body = {
        modulename: dashboardApiIndex.modulename.dashboard,
        methodname: dashboardApiIndex.methodname.empTeamData,
        payload: {
            roleId: encryptStorage.getItem('employeeId'),
        },
    };
    const response = await dashboardClient(body);

    /**
     * Pc_Tc_09
     * The response from axios gets returned to the employeeTEamComponent.jsx
     */
    return response;
};

/**
 * PC_Gc_08
 * The methodname , module name and url are got form constant.js file and passed in the body for dashBoardClient function
 */

export const getEmpGoalData = async (data = '') => {
    let body = {
        modulename: dashboardApiIndex.modulename.dashboard,
        methodname: dashboardApiIndex.methodname.empGoalData,
        payload: {
            roleId: encryptStorage.getItem('employeeId'),
        },
    };
    const response = await dashboardClient(body);

    /**
     * Pc_Gc_09
     * The response from axios gets returned to the employeeGoalComponent.jsx
     */
    return response;
};

export const getFormPopUp = async (data = '') => {
    //

    let body = {
        modulename: dashboardApiIndex.modulename.dashboard,
        methodname: dashboardApiIndex.methodname.formPopUp,
        payload: {
            roleId: encryptStorage.getItem('employeeId'),
        },
    };
    const response = await dashboardClient(body);

    //

    return response;
};

/**
 * PC_Pc_08
 * The methodname , module name and url are got form constant.js file and passed in the body for dashBoardClient function
 */

export const getPerformanceData = async (data = '', role) => {
    let year = '',
        domain = '';
    // if (role == 'Entire Team') {
    //     domain = encryptStorage.getItem('department');
    // }
    if (data.year || data.domain) {
        year = data.year;
        if (year) year = moment(year).format('YYYY');
        domain = data.domain;
    }
    let body = {
        modulename: dashboardApiIndex.modulename.dashboard,
        methodname: dashboardApiIndex.methodname.performanceData,
        payload: {
            role: role,
            roleId: encryptStorage.getItem('employeeId'),
            domain: domain,
            year: year,
        },
    };
    const response = await dashboardClient(body);

    /**
     * Pc_Pc_09
     * The response from axios gets returned to the performanceComponent.jsx
     */
    return response;
};
/**
 * PC_Lc_08
 * The methodname , module name and url are got form constant.js file and passed in the body for dashBoardClient function
 */
export const getLeaveData = async (data = '', role) => {
    let year = '',
        domain = '';
    // if (role == 'Entire Team') {
    //     domain = encryptStorage.getItem('department');
    // }
    if (data.year || data.domain) {
        year = data.year;
        if (year) year = moment(year).format('YYYY');
        domain = data.domain;
    }
    let body = {
        modulename: dashboardApiIndex.modulename.dashboard,
        methodname: dashboardApiIndex.methodname.leaveData,
        payload: {
            role: role,
            roleId: encryptStorage.getItem('employeeId'),
            domain: domain,
            year: year,
        },
    };
    const response = await dashboardClient(body);

    /**
     * Pc_Lc_09
     * The response from axios gets returned to the leaveChartComponent.jsx
     */
    return response;
};

/**
 * PC_Fc_08
 * The methodname , module name and url are got form constant.js file and passed in the body for dashBoardClient function
 */
export const getFeedbackData = async (data = '', role) => {
    let start_date = '',
        end_date = '',
        domain = '';
    // if (role == 'Entire Team') {
    //     domain = encryptStorage.getItem('department');
    // }
    if (data.domain || data.dates) {
        domain = data.domain;
        start_date = data?.dates?.split('||')[0] || '';
        end_date = data?.dates?.split('||')[1] || '';
    }
    let body = {
        modulename: dashboardApiIndex.modulename.dashboard,
        methodname: dashboardApiIndex.methodname.feedbackData,
        payload: {
            role: role,
            roleId: encryptStorage.getItem('employeeId'),
            domain: domain,
            start_date: start_date,
            end_date: end_date,
        },
    };
    const response = await dashboardClient(body);

    /**
     * Pc_Fc_09
     * The response from axios gets returned to the feedbackChartComponent.jsx
     */
    return response;
};

export const composeApi = async (message) => {
    try {
        const publicKeyPem =
            '-----BEGIN PUBLIC KEY-----\nMIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAoeMaWzPKrPSqUbVWjong\njo6pW709PxAf1HLAscXMTlqQ2jy3rBqqwD8EZ2vxoTMVY/PF1pJboseuNjNESZqw\nZYaSeMAKO1IpfHt9+jEoRsFmFFqRFq0kTQjmB1vA1dB1b2GSsP/Oc3fry18febOj\njVfSVHyzpzeyEJ/u5/swe7IafxUpwZEiUKKO4H73BRMqSLdNMmIAxochqiX2+5hr\nKAfMybcsePwjppC18wJxSAMoARPBZBXKHA38h1zkSjHTceoW8E29fXJ7QYHpJBwh\nI03Dq5rlYdhEnnLsN4hSXf8E0a1Jw6+ZnpxasSGcRXI3WIDSgYM1VGOtiZNcBZQB\nnwIDAQAB\n-----END PUBLIC KEY-----\n';
        const publicKey = forge.pki.publicKeyFromPem(publicKeyPem);

        // Generate a random AES key
        const aesKey = forge.random.getBytesSync(32); // 32 bytes = 256 bits

        // Encrypt the message with the AES key
        const cipher = forge.cipher.createCipher('AES-GCM', aesKey);
        const iv = forge.random.getBytesSync(12);
        cipher.start({ iv: iv });
        cipher.update(forge.util.createBuffer(message));
        cipher.finish();
        const encryptedMessage = cipher.output.getBytes();
        const tag = cipher.mode.tag.getBytes();

        // Encrypt the AES key with the RSA public key
        const encryptedKey = publicKey.encrypt(aesKey, 'RSA-OAEP', {
            md: forge.md.sha256.create(),
            mgf: forge.mgf.mgf1.create(forge.md.sha1.create()), // Use 'mgf' from 'forge.mgf'
        });

        // Encode the encrypted data for transmission
        const payload = {
            iv: forge.util.encode64(iv),
            key: forge.util.encode64(encryptedKey),
            message: forge.util.encode64(encryptedMessage),
            tag: forge.util.encode64(tag),
        };

        return payload;
    } catch (error) {
        throw error;
    }
};

// export function dataGrid(encrypt) {
//     var result = "";
//     for (var i = 0; i < encrypt.length; i++) {
//       result += encrypt.charAt(i);

//       if (i < encrypt.length - 1) {
//         i++;
//       }
//     }
//     let kilo = result;
//     let key = kilo.slice(0, -83);
//     let key2 = key.slice(38)
//     let DataStreamX = key2.slice(0, -7);
//     let rndString = key2.slice(-7);
//     let secretKey = `REACT_APP_DATA_GRAPH_${rndString}`;
//     let ivKey = `REACT_APP_AUTH_GUARD_${rndString}`;
//     const decryptedBytes = AES.decrypt(DataStreamX, process.env[secretKey], {
//       iv: process.env[ivKey],
//     });
//     const decryptedData = decryptedBytes.toString(enc.Utf8);
//     const decryptedObject = JSON.parse(decryptedData);
//     return decryptedObject;
//   }
/**
 * PC_Tc_08
 * The methodname , module name and url are got form constant.js file and passed in the body for dashBoardClient function
 */
export const getTeamCountData = async (data = '') => {
    let start_date = '',
        end_date = '';
    if (data) {
        start_date = data?.start_date ? data.start_date : '';
        end_date = data?.end_date ? data.end_date : '';
    }
    let body = {
        modulename: dashboardApiIndex.modulename.dashboard,
        methodname: dashboardApiIndex.methodname.teamCountData,
        payload: {
            role: encryptStorage.getItem('role'),
            roleId: encryptStorage.getItem('employeeId'),
            start_date: start_date,
            end_date: end_date,
        },
    };
    const response = await dashboardClient(body);

    /**
     * Pc_Tc_09
     * The response from axios gets returned to the TEACMcOUNThartComponent.jsx
     */
    return response;
};

/**
 * PC_Rc_08
 * The methodname , module name and url are got form constant.js file and passed in the body for dashBoardClient function
 */
export const getRatingData = async (data = '', role) => {
    let start_date = '',
        end_date = '',
        domain = '';
    // if (role == 'Entire Team') {
    //     domain = encryptStorage.getItem('department');
    // }
    if (data.domain || data.dates) {
        domain = data.domain;
        start_date = data.dates.split('||')[0];
        end_date = data.dates.split('||')[1];
    }
    let body = {
        modulename: dashboardApiIndex.modulename.dashboard,
        methodname: dashboardApiIndex.methodname.ratingData,
        payload: {
            role: role,
            roleId: encryptStorage.getItem('employeeId'),
            domain: domain,
            start_date: start_date,
            end_date: end_date,
        },
    };
    const response = await dashboardClient(body);

    /**
     * Pc_Rc_09
     * The response from axios gets returned to the RatinghartComponent.jsx
     */
    return response;
};

/**
 * PC_Sc_08
 * The methodname , module name and url are got form constant.js file and passed in the body for dashBoardClient function
 */
export const getSalaryData = async (data = '', role) => {
    let start_date = '',
        end_date = '',
        domain = '';
    // if (role == 'Entire Team') {
    //     domain = encryptStorage.getItem('department');
    // }
    if (data.start_date || data.end_date || data.domain) {
        start_date = data?.start_date ? data.start_date : '';
        end_date = data?.end_date ? data?.end_date : '';
        domain = data?.domain ? data?.domain : '';
    }
    let body = {
        modulename: dashboardApiIndex.modulename.dashboard,
        methodname: dashboardApiIndex.methodname.salaryData,
        payload: {
            role: role,
            roleId: encryptStorage.getItem('employeeId'),
            domain: domain,
            start_date: start_date,
            end_date: end_date,
        },
    };
    const response = await dashboardClient(body);

    /**
     * Pc_Sc_09
     * The response from axios gets returned to the SalaryChartComponent.jsx
     */
    return response;
};

/**
 * PC_Mc_08
 * The methodname , module name and url are got form constant.js file and passed in the body for dashBoardClient function
 */
export const getMoodData = async (data = '', role) => {
    let domain = '',
        start_date = '',
        end_date = '';
    // if(role=="Entire Team"){
    //     domain = encryptStorage.getItem('department');
    // }
    if (data.domain || data.start_date || data.end_date) {
        domain = data?.domain ? data?.domain : '';
        start_date = data?.start_date ? data?.start_date : '';
        end_date = data?.end_date ? data?.end_date : '';
    }
    let body = {
        modulename: dashboardApiIndex.modulename.dashboard,
        methodname: dashboardApiIndex.methodname.moodData,
        payload: {
            role: role,
            roleId: encryptStorage.getItem('employeeId'),
            domain: domain,
            start_date: start_date,
            end_date: end_date,
        },
    };
    const response = await dashboardClient(body);

    /**
     * Pc_Mc_09
     * The response from axios gets returned to the MoodChartComponent.jsx
     */
    return response;
};

/**
 * PC_Ac_08
 * The methodname , module name and url are got form constant.js file and passed in the body for dashBoardClient function
 */
export const getAttritionData = async (data = '', role) => {
    let year = '',
        domain = '';
    // if(role=="Entire Team"){
    //     domain = encryptStorage.getItem('department');
    // }
    if (data.year || data.domain) {
        year = data.year;
        if (year) year = moment(year).format('YYYY');
        domain = data.domain;
    }
    let body = {
        modulename: dashboardApiIndex.modulename.dashboard,
        methodname: dashboardApiIndex.methodname.attritionData,
        payload: {
            role: role,
            roleId: encryptStorage.getItem('employeeId'),
            domain: domain,
            year: year,
        },
    };

    const response = await dashboardClient(body);

    /**
     * Pc_Ac_09
     * The response from axios gets returned to the AttritionChartComponent.jsx
     */
    return response;
};

export const getMoodGridData = async (data = '', roles) => {
    let reason = '',
        mood = '',
        domain = '';
    if (data?.reason) reason = data.reason;
    if (data?.mood) mood = data.mood;
    if (data?.domain) domain = data.domain;
    let body = {
        modulename: dashboardApiIndex.modulename.dashboard,
        methodname: dashboardApiIndex.methodname.moodGridData,
        payload: {
            role: roles,
            roleId: encryptStorage.getItem('employeeId'),
            domain: domain,
            mood: mood,
            reason: reason,
            start_date: data?.start_date ? data.start_date : moment().startOf('month').format('YYYY-MM-DD'),
            end_date: data?.end_date ? data.end_date : moment().endOf('month').format('YYYY-MM-DD'),
            limit: data?.limit ? data.limit : 10,
            sortColumn: data?.sortColumn || '',
            sortOrder: data?.sortOrder || '',
        },
    };
    const response = await dashboardClient(body);

    return response;
};
export const getDomainData = async (data = '') => {
    let body = {
        modulename: dashboardApiIndex.modulename.dashboard,
        methodname: dashboardApiIndex.methodname.domainData,
        payload: {},
    };
    const response = await dashboardClient(body);
    return response;
};
export const getEvaluationData = async (data = '') => {
    let body = {
        modulename: dashboardApiIndex.modulename.dashboard,
        methodname: dashboardApiIndex.methodname.evalData,
        payload: {},
    };
    const response = await dashboardClient(body);
    return response;
};
export const getMoodReasonsData = async (data = '') => {
    let body = {
        modulename: dashboardApiIndex.modulename.dashboard,
        methodname: dashboardApiIndex.methodname.moodReasonsData,
        payload: {},
    };
    const response = await dashboardClient(body);
    return response;
};
export const getMoodAnalyticData = async (data = '') => {
    let start_date = moment().startOf('month').format('YYYY-MM-DD'),
        end_date = moment().endOf('month').format('YYYY-MM-DD');
    if (data == '') {
        start_date = moment().startOf('month').format('YYYY-MM-DD');
        end_date = moment().endOf('month').format('YYYY-MM-DD');
    } else {
        start_date = data.startDate;
        end_date = data.endDate;
    }
    let body = {
        modulename: dashboardApiIndex.modulename.dashboard,
        methodname: dashboardApiIndex.methodname.moodAnalyticData,
        payload: {
            role: data.role,
            roleId: encryptStorage.getItem('employeeId'),
            start_date: start_date,
            end_date: end_date,
            domain: data.domain,
        },
    };
    const response = await dashboardClient(body);
    return response;
};
export const getReasonsData = async (data = '') => {
    let body = {
        modulename: dashboardApiIndex.modulename.dashboard,
        methodname: dashboardApiIndex.methodname.reasonData,
        payload: {},
    };
    const response = await dashboardClient(body);
    return response;
};
export const postMoodData = async (data = '') => {
    let body = {
        modulename: dashboardApiIndex.modulename.dashboard,
        methodname: dashboardApiIndex.methodname.postMood,
        payload: {
            role: encryptStorage.getItem('role'),
            roleId: encryptStorage.getItem('employeeId'),
            data: {
                comment: data.comment,
                mood_id: data.mood,
                reasons: data.reasons,
            },
        },
    };
    const response = await dashboardClient(body);
    return response;
};

/**
 * PC_MLc_08
 * The methodname , module name and url are got form constant.js file and passed in the body for dashBoardClient function
 */

export const empLeaveData = async (data = '') => {
    let body = {
        modulename: dashboardApiIndex.modulename.dashboard,
        methodname: dashboardApiIndex.methodname.empLeave2,
        payload: {
            role: encryptStorage.getItem('role'),
            roleId: encryptStorage.getItem('employeeId'),
        },
    };

    const response = await dashboardClient(body);

    /**
     * Pc_MLc_09
     * The response from axios gets returned to the employeeLeaveChartComponent.jsx
     */

    return response;
};

export const previousEvaluationId = async (data = '') => {
    //

    let body = {
        modulename: dashboardApiIndex.modulename.dashboard,
        methodname: dashboardApiIndex.methodname.previousEvaluation,
        payload: {},
    };

    const response = await dashboardClient(body);

    return response;
};

export const setEvaluationPeriodApi = async (data = '') => {
    //

    let body = {
        modulename: dashboardApiIndex.modulename.dashboard,
        methodname: dashboardApiIndex.methodname.setEvaluationPeriod,
        payload: {},
    };

    const response = await dashboardClient(body);

    return response;
};
export const generateBulkOfferLetter = async (data = '') => {
    let body = {
        modulename: dashboardApiIndex.modulename.recruitment,
        methodname: dashboardApiIndex.methodname.generateBulkOffer,
        payload: {},
    };
    const response = await dashboardClient(body);
    return response;
};
